import { render, staticRenderFns } from "./DefaultNotification.vue?vue&type=template&id=e794562a&scoped=true&lang=pug&"
import script from "./DefaultNotification.vue?vue&type=script&lang=js&"
export * from "./DefaultNotification.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNotification.vue?vue&type=style&index=0&id=e794562a&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e794562a",
  null
  
)

export default component.exports